/* eslint-disable @typescript-eslint/naming-convention */
export interface AuthorisationRight {
  code: string;
  description?: string;
  route?: string;
  method?: Method;
}

enum Method {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATCH = 'PATCH',
}
export const SPECIFIC_TRAINERS_RIGHTS: Record<string, AuthorisationRight> = {
  MEAN_LISTING: {
    code: 'MEAN_LISTING_TRAINER',
    description: 'mean listing for trainers',
  },
  MEAN_EDIT: {
    code: 'MEAN_EDIT_TRAINER',
    description: 'mean edition for trainers',
  },
  MEAN_SHOW: {
    code: 'MEAN_SHOW_TRAINER',
    description: 'mean show for trainers',
  },
};

export const AUTHORISATION_RIGHT: Record<string, AuthorisationRight> = {
  JUMP: {
    code: 'JUMP',
    description: 'droit des admin++ de JUMP',
  },
  BIZNESS: {
    code: 'BIZNESS',
    description: 'droit des admin++ de BIZNESS',
  },
  CLIENT_SHOW_CURRENT: {
    code: 'CLIENT_SHOW_CURRENT',
    description: 'get current client',
    route: '/api/admin/client/current',
    method: Method.GET,
  },
  CLIENT_SHOW: {
    code: 'CLIENT_SHOW',
    description: 'get details of any client',
    route: '/api/admin/client/:id',
    method: Method.GET,
  },
  CLIENT_SHOW_OWN: {
    code: 'CLIENT_SHOW_OWN',
    description: 'get details of a sub client',
    route: '/api/admin/client/:id',
    method: Method.GET,
  },
  CLIENT_LISTING_OWN: {
    code: 'CLIENT_LISTING_OWN',
    description: 'get own clients',
    route: '/api/admin/client',
    method: Method.GET,
  },
  CLIENT_CREATE: {
    code: 'CLIENT_CREATE',
    description: 'create all type of client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  'CLIENT_CREATE_OF+': {
    code: 'CLIENT_CREATE_OF+',
    description: 'create OF+ client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_CREATE_OF: {
    code: 'CLIENT_CREATE_OF',
    description: 'create OF client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_CREATE_INDE: {
    code: 'CLIENT_CREATE_INDE',
    description: 'create INDE client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  'CLIENT_CREATE_CLIENT+': {
    code: 'CLIENT_CREATE_CLIENT+',
    description: 'create client+ client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_CREATE_CLIENTBO: {
    code: 'CLIENT_CREATE_CLIENTBO',
    description: 'create back office client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_CREATE_CLIENTFO: {
    code: 'CLIENT_CREATE_CLIENTFO',
    description: 'create front office client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_CREATE_INTERNE: {
    code: 'CLIENT_CREATE_INTERNE',
    description: 'create internal client',
    method: Method.POST,
    route: '/api/admin/client',
  },
  CLIENT_EDIT_CURRENT: {
    code: 'CLIENT_EDIT_CURRENT',
    description: 'edit current client',
    method: Method.PUT,
    route: '/api/admin/client/current',
  },
  CLIENT_EDIT: {
    code: 'CLIENT_EDIT',
    description: 'edit client any sub client',
    method: Method.PUT,
    route: '/api/admin/client/:id',
  },
  CLIENT_CREATE_SIGNATURE_CURRENT: {
    code: 'CLIENT_CREATE_SIGNATURE_CURRENT',
    description: 'can upload a signature for the current client',
    method: Method.POST,
    route: '/api/admin/client/signature',
  },
  CLIENT_CREATE_SIGNATURE: {
    code: 'CLIENT_CREATE_SIGNATURE',
    description: 'can upload a signature for sub client',
    method: Method.POST,
    route: '/api/admin/client/:id/signature',
  },
  CLIENT_SHOW_SIGNATURE: {
    code: 'CLIENT_SHOW_SIGNATURE',
    description: 'get the client signature',
    route: '/api/admin/client/:id/decrypt/signature',
    method: Method.POST,
  },
  CLIENT_SHOW_SIGNATURE_CURRENT: {
    code: 'CLIENT_SHOW_SIGNATURE_CURRENT',
    description: 'get the current client signature',
    route: '/api/admin/client/:id/decrypt/signature',
    method: Method.POST,
  },
  CLIENT_AFFECTATION_LISTING: {
    code: 'CLIENT_AFFECTATION_LISTING',
    description: 'get current client affectations values',
    route: '/api/admin/client/listing/affectation_criterias',
    method: Method.GET,
  },
  CLIENT_CREATE_PICTO: {
    code: 'CLIENT_CREATE_PICTO',
    description: 'upload picto for client',
    route: '/api/admin/client/:id/picto',
    method: Method.GET,
  },
  CLIENT_CREATE_LOGO: {
    code: 'CLIENT_CREATE_LOGO',
    description: 'upload logo for client',
    route: '/api/admin/client/logo',
    method: Method.GET,
  },
  CLIENT_SWITCH_CLIENT: {
    code: 'CLIENT_SWITCH_CLIENT',
    description: 'permit an admin to switch current client',
    method: Method.PUT,
    route: '/api/admin/switch-client/:id',
  },
  USER_SHOW: {
    code: 'USER_SHOW',
    description: 'Get an user detail',
    route: '/api/admin/user/:identifier',
    method: Method.GET,
  },
  USER_SHOW_OWN: {
    code: 'USER_SHOW_OWN',
    description: 'Get a sub user detail',
    route: '/api/admin/user/:identifier',
    method: Method.GET,
  },
  USER_LISTING: {
    code: 'USER_LISTING',
    description: 'Get user listing',
    route: '/api/admin/user',
    method: Method.GET,
  },
  USER_CREATE: {
    code: 'USER_CREATE',
    description: 'create an user of any type',
    method: Method.POST,
    route: '/api/admin/user',
  },
  'USER_CREATE_ADMIN++': {
    code: 'USER_CREATE_ADMIN++',
    description: 'create an user of type admin++',
    method: Method.POST,
    route: '/api/admin/user',
  },
  USER_CREATE_ADMIN: {
    code: 'USER_CREATE_ADMIN',
    description: 'create an user of type admin',
    method: Method.POST,
    route: '/api/admin/user',
  },
  USER_DELETE_OWN: {
    code: 'USER_DELETE_OWN',
    description: 'delete user except admin++ if user is admin',
    method: Method.DELETE,
    route: '/api/admin',
  },
  USER_DELETE: {
    code: 'USER_DELETE',
    description: 'delete user if user is admin++',
    method: Method.DELETE,
    route: '/api/admin/user',
  },
  USER_CREATE_MANAGER: {
    code: 'USER_CREATE_MANAGER',
    description: 'create an user of type manager',
    method: Method.POST,
    route: '/api/admin/user',
  },
  USER_CREATE_FORMATEUR: {
    code: 'USER_CREATE_FORMATEUR',
    description: 'create an user of type formateur',
    method: Method.POST,
    route: '/api/admin/user',
  },
  USER_CREATE_APPRENANT: {
    code: 'USER_CREATE_APPRENANT',
    description: 'create an user of type apprenant',
    method: Method.POST,
    route: '/api/admin/user',
  },
  USER_EDIT_OWN: {
    code: 'USER_EDIT_OWN',
    description: 'update a sub user',
    method: Method.PUT,
    route: '/api/admin/user/:identifier',
  },
  USER_EDIT: {
    code: 'USER_EDIT',
    description: 'update a any user',
    method: Method.PUT,
    route: '/api/admin/user/:identifier',
  },
  USER_EDIT_CURRENT: {
    code: 'USER_EDIT_CURRENT',
    description: 'update the current user',
    method: Method.PUT,
    route: '/api/admin/user/current',
  },
  USER_EDIT_CURRENT_PASSWORD: {
    code: 'USER_EDIT_CURRENT',
    description: 'update the current password',
    method: Method.PATCH,
    route: '/api/admin/user/current',
  },
  USER_EXPERT: {
    code: 'USER_EXPERT',
    description: 'User is expert for at least one product',
  },
  USER_PRODUCT_LISTING_OWN: {
    code: 'USER_PRODUCT_LISTING_OWN',
    description: 'get own user product',
    method: Method.GET,
    route: '/api/user/product',
  },
  USER_PRODUCT_LISTING: {
    code: 'USER_PRODUCT_LISTING',
    description: 'get user product',
    method: Method.GET,
    route: '/api/user/product?query=:userIdentifier',
  },
  PRODUCT_LISTING_GAME: {
    code: 'PRODUCT_LISTING_GAME',
    description: 'get all game product',
    method: Method.GET,
    route: '/api/admin/game',
  },
  PRODUCT_LISTING_LEARNIZ: {
    code: 'PRODUCT_LISTING_LEARNIZ',
    description: 'get all learniz product',
    method: Method.GET,
    route: '/api/admin/learniz',
  },
  PRODUCT_LISTING_COURSIZ: {
    code: 'PRODUCT_LISTING_COURSIZ',
    description: 'get all coursiz product',
    method: Method.GET,
    route: '/api/admin/coursiz',
  },
  PRODUCT_LISTING_CLASSIZ: {
    code: 'PRODUCT_LISTING_CLASSIZ',
    description: 'get all classiz product',
    method: Method.GET,
    route: '/api/admin/classiz',
  },
  PRODUCT_LISTING_SCORM: {
    code: 'PRODUCT_LISTING_SCORM',
    description: 'get all scorm product',
    method: Method.GET,
    route: '/api/admin/scorm',
  },
  PRODUCT_SHOW_GAME: {
    code: 'PRODUCT_SHOW_GAME',
    description: 'get detail of product game',
    method: Method.GET,
    route: '/api/admin/game/:productSlug',
  },
  PRODUCT_SHOW_LEARNIZ: {
    code: 'PRODUCT_SHOW_LEARNIZ',
    description: 'get detail of product learniz',
    method: Method.GET,
    route: '/api/admin/learniz/:productSlug',
  },
  PRODUCT_SHOW_COURSIZ: {
    code: 'PRODUCT_SHOW_COURSIZ',
    description: 'get detail of product coursiz',
    method: Method.GET,
    route: '/api/admin/coursiz/:productSlug',
  },
  PRODUCT_SHOW_SCORM: {
    code: 'PRODUCT_SHOW_SCORM',
    description: 'get detail of product scorm',
    method: Method.GET,
    route: '/api/admin/scorm/:productSlug',
  },
  PRODUCT_CREATE_GAME: {
    code: 'PRODUCT_CREATE_GAME',
    description: 'create product game',
    method: Method.POST,
    route: '/api/admin/game',
  },
  PRODUCT_CREATE_LEARNIZ: {
    code: 'PRODUCT_CREATE_LEARNIZ',
    description: 'create product learniz',
    method: Method.POST,
    route: '/api/admin/learniz',
  },
  PRODUCT_CREATE_COURSIZ: {
    code: 'PRODUCT_CREATE_COURSIZ',
    description: 'create product coursiz',
    method: Method.POST,
    route: '/api/admin/coursiz',
  },
  PRODUCT_CREATE_SCORM: {
    code: 'PRODUCT_CREATE_SCORM',
    description: 'create product scorm',
    method: Method.POST,
    route: '/api/admin/scorm',
  },
  PRODUCT_CREATE_CLASSIZ: {
    code: 'PRODUCT_CREATE_CLASSIZ',
    description: 'create product classiz',
    method: Method.POST,
    route: '/api/admin/classiz',
  },
  PRODUCT_EDIT_GAME: {
    code: 'PRODUCT_EDIT_GAME',
    description: 'update product game',
    method: Method.PUT,
    route: '/api/admin/game/:productSlug',
  },
  PRODUCT_EDIT_LEARNIZ: {
    code: 'PRODUCT_EDIT_LEARNIZ',
    description: 'update product learniz',
    method: Method.PUT,
    route: '/api/admin/learniz/:productSlug',
  },
  PRODUCT_EDIT_COURSIZ: {
    code: 'PRODUCT_EDIT_COURSIZ',
    description: 'update product coursiz',
    method: Method.PUT,
    route: '/api/admin/coursiz/:productSlug',
  },
  PRODUCT_EDIT_SCORM: {
    code: 'PRODUCT_EDIT_SCORM',
    description: 'update product scorm',
    method: Method.PUT,
    route: '/api/admin/scorm/:productSlug',
  },
  PRODUCT_PUBLISH_GAME: {
    code: 'PRODUCT_PUBLISH_GAME',
    description: 'publish product game',
    method: Method.PATCH,
    route: '/api/admin/game/:productSlug',
  },
  PRODUCT_PUBLISH_LEARNIZ: {
    code: 'PRODUCT_PUBLISH_LEARNIZ',
    description: 'publish product learniz',
    method: Method.PATCH,
    route: '/api/admin/learniz/:productSlug',
  },
  PRODUCT_PUBLISH_COURSIZ: {
    code: 'PRODUCT_PUBLISH_COURSIZ',
    description: 'publish product coursiz',
    method: Method.PATCH,
    route: '/api/admin/coursiz/:productSlug',
  },
  PRODUCT_PUBLISH_SCORM: {
    code: 'PRODUCT_PUBLISH_SCORM',
    description: 'publish product scorm',
    method: Method.PATCH,
    route: '/api/admin/scorm/:productSlug',
  },
  PRODUCT_DUPLICATE_GAME: {
    code: 'PRODUCT_DUPLICATE_GAME',
    description: 'duplicate product game',
    method: Method.PUT,
    route: '/api/admin/game/duplicate/:productSlug',
  },
  PRODUCT_DUPLICATE_LEARNIZ: {
    code: 'PRODUCT_DUPLICATE_LEARNIZ',
    description: 'duplicate product learniz',
    method: Method.PUT,
    route: '/api/admin/learniz/duplicate/:productSlug',
  },
  PRODUCT_DUPLICATE_COURSIZ: {
    code: 'PRODUCT_DUPLICATE_COURSIZ',
    description: 'duplicate product coursiz',
    method: Method.PUT,
    route: '/api/admin/coursiz/duplicate/:productSlug',
  },
  PRODUCT_DUPLICATE_SCORM: {
    code: 'PRODUCT_DUPLICATE_SCORM',
    description: 'duplicate product scorm',
    method: Method.PUT,
    route: '/api/admin/scorm/duplicate/:productSlug',
  },
  PRODUCT_DUPLICATE_CLASSIZ: {
    code: 'PRODUCT_DUPLICATE_CLASSIZ',
    description: 'duplicate product classiz',
    method: Method.PUT,
    route: '/api/admin/classiz/duplicate/:productSlug',
  },
  PRODUCT_DRAFT_GAME: {
    code: 'PRODUCT_DRAFT_GAME',
    description: 'edit draft of product game',
    method: Method.PATCH,
    route: '/api/admin/game/:productSlug',
  },
  PRODUCT_DRAFT_LEARNIZ: {
    code: 'PRODUCT_DRAFT_LEARNIZ',
    description: 'edit draft of product learniz',
    method: Method.PATCH,
    route: '/api/admin/learniz/:productSlug',
  },
  PRODUCT_DRAFT_COURSIZ: {
    code: 'PRODUCT_DRAFT_COURSIZ',
    description: 'edit draft of product coursiz',
    method: Method.PATCH,
    route: '/api/admin/coursiz/:productSlug',
  },
  PRODUCT_DRAFT_SCORM: {
    code: 'PRODUCT_DRAFT_SCORM',
    description: 'edit draft of product scorm',
    method: Method.PATCH,
    route: '/api/admin/scorm/:productSlug',
  },
  PRODUCT_PREVIEW_GAME: {
    code: 'PRODUCT_PREVIEW_GAME',
    description: 'create link to preview a game',
    method: Method.GET,
    route: '/api/admin/game/:productSlug/preview',
  },
  PRODUCT_PREVIEW_LEARNIZ: {
    code: 'PRODUCT_PREVIEW_LEARNIZ',
    description: 'create link to preview a learniz',
    method: Method.GET,
    route: '/api/admin/learniz/:productSlug/preview',
  },
  PRODUCT_PREVIEW_COURSIZ: {
    code: 'PRODUCT_PREVIEW_COURSIZ',
    description: 'create link to preview a coursiz',
    method: Method.GET,
    route: '/api/admin/coursiz/:productSlug/preview',
  },
  PRODUCT_PREVIEW_SCORM: {
    code: 'PRODUCT_PREVIEW_SCORM',
    description: 'create link to preview a scorm',
    method: Method.GET,
    route: '/api/admin/scorm/:productSlug/preview',
  },
  PRODUCT_LINK_GAME: {
    code: 'PRODUCT_LINK_GAME',
    description: 'create sso link to access a game',
    method: Method.POST,
    route: '/api/admin/game/:productSlug/link',
  },
  PRODUCT_LINK_LEARNIZ: {
    code: 'PRODUCT_LINK_LEARNIZ',
    description: 'create sso link to access a learniz',
    method: Method.POST,
    route: '/api/admin/learniz/:productSlug/link',
  },
  PRODUCT_LINK_COURSIZ: {
    code: 'PRODUCT_LINK_COURSIZ',
    description: 'create sso link to access a coursiz',
    method: Method.POST,
    route: '/api/admin/coursiz/:productSlug/link',
  },
  PRODUCT_LINK_SCORM: {
    code: 'PRODUCT_LINK_SCORM',
    description: 'create sso link to access a scorm',
    method: Method.POST,
    route: '/api/admin/scorm/:productSlug/link',
  },
  PRODUCT_SCORM_EXPORT: {
    code: 'PRODUCT_SCORM_EXPORT',
    description: 'export a product to scorm',
    method: Method.POST,
    route: '/api/admin/scorm',
  },
  DOCUMENT_LISTING: {
    code: 'DOCUMENT_LISTING',
    description: 'get list of documents',
  },
  DOCUMENT_LISTING_PARAMS: {
    code: 'DOCUMENT_LISTING_PARAMS',
    description: 'get list of documents params',
  },
  DOCUMENT_EDIT_TCHAT: {
    code: 'DOCUMENT_EDIT_TCHAT',
    description: 'upload medias in front-dynamic',
  },
  DOCUMENT_EDIT: {
    code: 'DOCUMENT_EDIT',
    description: 'can upload, edit, delete of documents',
  },
  DOCUMENT_EDIT_PARAMS: {
    code: 'DOCUMENT_EDIT_PARAMS',
    description: 'can upload, edit, delete of documents params',
  },
  MEAN_LISTING: {
    code: 'MEAN_LISTING',
    description: 'mean listing',
    method: Method.GET,
    route: '/admin/mean',
  },
  MEAN_CREATE: {
    code: 'MEAN_CREATE',
    description: 'mean creation',
    method: Method.POST,
    route: '/admin/mean',
  },
  MEAN_EDIT: {
    code: 'MEAN_EDIT',
    description: 'mean edition',
    method: Method.GET,
    route: '/admin/mean/:meanSlug',
  },
  MEAN_SHOW: {
    code: 'MEAN_SHOW',
    description: 'mean show',
    method: Method.GET,
    route: '/admin/mean/details/:meanSlug',
  },
  MEAN_PUBLISH: {
    code: 'MEAN_SHOW',
    description: 'mean show',
    method: Method.GET,
    route: '/admin/mean/:meanSlug/publish',
  },
  MEAN_ZIP_ATTESTATIONS: {
    code: 'MEAN_ZIP_ATTESTATIONS',
    description: 'can download all attestations of a mean',
  },
  STATS_READ: {
    code: 'STATS_READ',
    description: 'Affichage des Statistiques',
  },
  STATS_READ_OWN: {
    code: 'STATS_READ_OWN',
    description: 'Affichage des Statistiques de son client',
  },
  ACCESS_BO: {
    code: 'ACCESS_BO',
    description: 'Permet de se connecter au bo',
  },
  ACCESS_FO: {
    code: 'FO',
    description: 'Permet de se connecter au fo',
  },
  EMAIL_TEMPLATES: {
    code: 'UPDATE_TEMPLATES',
    description: 'Supprimer les emails des templates',
  },
  EMAIL_DEFAULT_TEMPLATES: {
    code: 'UPDATE_DEFAULT_TEMPLATES',
    description: 'Supprimer les emails des templates',
  },
  IMPERSONATE_CLIENT: {
    code: 'IMPERSONATE_CLIENT',
    description: 'Can impersonate',
  },
  PRODUCT_CREATE_SURVEY: {
    code: 'PRODUCT_CREATE_SURVEY',
    description: 'Can create survey product',
  },
  PRODUCT_SHOW_SURVEY: {
    code: 'PRODUCT_SHOW_SURVEY',
    description: 'Can see survey product',
  },
  PRODUCT_EDIT_SURVEY: {
    code: 'PRODUCT_EDIT_SURVEY',
    description: 'Can edit survey product',
  },
  PRODUCT_LINK_SURVEY: {
    code: 'PRODUCT_LINK_SURVEY',
    description: 'Can link survey product to mean?',
  },
  PRODUCT_DRAFT_SURVEY: {
    code: 'PRODUCT_DRAFT_SURVEY',
    description: 'Can save draft survey product',
  },
  PRODUCT_PUBLISH_SURVEY: {
    code: 'PRODUCT_PUBLISH_SURVEY',
    description: 'Can publish survey product',
  },
  PRODUCT_DUPLICATE_SURVEY: {
    code: 'PRODUCT_DUPLICATE_SURVEY',
    description: 'Can duplicate survey product',
  },
  PRODUCT_LISTING_SURVEY: {
    code: 'PRODUCT_LISTING_SURVEY',
    description: 'Can display survey product list',
  },
  ADD_EDIT_LICENCE: {
    code: 'ADD_EDIT_LICENCE',
    description: 'Can display licence for admin++ and admin (jump and bizness client)',
  },
  USER_COLLABORATOR_LISTING: {
    code: 'USER_COLLABORATOR_LISTING',
    description: 'Can display users managed by the current user',
  },
  PRODUCT_SHARE: {
    code: 'PRODUCT_SHARE',
    description: 'Authorize admin++ and admin (jump and bizness client) to share products with other clients',
  },
  PRODUCT_CREATE_SMART_SEQUENCE: {
    code: 'PRODUCT_CREATE_SMART_SEQUENCE',
    description: 'create product smart-sequence',
    method: Method.POST,
    route: '/api/admin/smart-sequence',
  },
  PRODUCT_EDIT_SMART_SEQUENCE: {
    code: 'PRODUCT_EDIT_SMART_SEQUENCE',
    description: 'update smart sequence smart sequence',
    method: Method.PUT,
    route: '/api/admin/smart-sequence/:slug',
  },
  PRODUCT_SHOW_SMART_SEQUENCE: {
    code: 'PRODUCT_SHOW_SMART_SEQUENCE',
    description: 'get detail of product smart sequence',
    method: Method.GET,
    route: '/api/admin/game/:slug',
  },
  PRODUCT_PUBLISH_SMART_SEQUENCE: {
    code: 'PRODUCT_PUBLISH_SMART_SEQUENCE',
    description: 'publish product smart sequence',
    method: Method.PATCH,
    route: '/api/admin/smart-sequence/:slug',
  },
  PRODUCT_LINK_SMART_SEQUENCE: {
    code: 'PRODUCT_LINK_SMART_SEQUENCE',
    description: 'create sso link to access a smart sequence',
    method: Method.POST,
    route: '/api/admin/smart-sequence/:slug/link',
  },
  PRODUCT_LISTING_SMART_SEQUENCE: {
    code: 'PRODUCT_LISTING_SMART_SEQUENCE',
    description: 'get all smart sequence product',
    method: Method.GET,
    route: '/api/admin/smart-sequence',
  },
  PRODUCT_PREVIEW_SMART_SEQUENCE: {
    code: 'PRODUCT_PREVIEW_SMART_SEQUENCE',
    description: 'create link to preview a smart sequence',
    method: Method.GET,
    route: '/api/admin/smart-sequence/:slug/preview',
  },
  PRODUCT_DUPLICATE_SMART_SEQUENCE: {
    code: 'PRODUCT_DUPLICATE_SMART_SEQUENCE',
    description: 'duplicate product smart sequence',
    method: Method.PUT,
    route: '/api/admin/smart-sequence/duplicate/:slug',
  },
};
